
import { SharedFactoryDataService } from 'projects/tmhna-portal/src/app/services/shared/shared-factory-data.service';
import { ConfirmPageLabels, ConfirmRegistrationState } from './definitions';

export class ConfirmRegistrationFactory 
{
	public static build(): ConfirmRegistrationState 
	{
		return {
			refreshPageButton: {
				size: 'medium',
				style: 'primary',
				disabled: false,
				label: '',
				icon: {
					altText: '',
					iconPath: ''
				},
				position: 'left'
			},
			logo: {
				altText: '',
				iconPath: ''
			},
			pageDescription: '',
			pageHeading: '',
			footer: {
				cssClass: '',
				ribbonImage: '',
				altText: '',
				footercontent: {
					css: {
						ecomm: ''
					},
					script: {},
					unifiedFooter: ''

				}
			},
			pageLabels: {
				pendingApproval: this.buildPageLabels(),
				pendingBusinessAccountApproval: this.buildPageLabels(),
				submittedRegistrationForReview: this.buildPageLabels()
			}, 
			loading: false
		};
	}
	public static buildPageLabels(): ConfirmPageLabels 
	{
		return {
			logo: SharedFactoryDataService.buildImage('', ''),
			mainText: '',
			refreshButton: { label: '', id: '' },
			subText: ''
		};
	}
}
